import { useCallback } from "react";
import { useDispatch } from "react-redux";
import { useAppState } from "../../../hooks/use-app-state";
import { PageCloseGenericErrorModal } from "../../../redux/page/actions/default";
import { PageState } from "../../../redux/page/state";

export const useGenericErrorModal = () => {
    const pageState = useAppState<PageState>("page");
    const dispatch = useDispatch();
    const close = useCallback(() => {
        dispatch(new PageCloseGenericErrorModal().create());
    }, []);
    return {
        opened: pageState.genericErrorModal?.opened,
        close,
    };
};
